import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Paragraph,
  ChecboxWrapper,
  CheckboxLabel,
  Checkbox,
  FakeNextButton,
  NextButton,
  SmallPrint,
} from "../styles/form-steps-styles";

const Terms = ({
  termsAccepted,
  candidateName,
  employerName,
  recruiterName,
  checkBoxOnChange,
  proceedToReview,
}) => (
  <Wrapper data-test-id="applicant-review-terms">
    <Paragraph welcome className="animated fadeIn delay-3">
      Hi {candidateName},
    </Paragraph>
    <Paragraph welcome className="animated fadeIn delay-4">
      Congratulations on your new job! As {recruiterName} helped you secure the
      position, they hoped you might be willing to leave them a review on Hiring
      Hub* - it helps them develop their reputation within the employer
      community.
    </Paragraph>
    <Paragraph welcome className="animated fadeIn delay-5">
      We&apos;re on a mission to champion and promote the best independent
      recruiters in the UK; our platform acts as a gateway, allowing employers
      like {employerName} to find and work with specialist recruiters to
      discover great candidates, like you!
    </Paragraph>
    <Paragraph welcome className="animated fadeIn delay-6">
      Hence, we&apos;d be grateful if you&apos;re able to contribute to that
      mission by leaving {recruiterName} a quick review and helping us make
      recruiting better for everyone. It&apos;ll take less than a minute. Click
      the button below to get started 🙌.
    </Paragraph>
    <ChecboxWrapper className="animated fadeIn delay-8">
      <Checkbox
        type="checkbox"
        id="one"
        onChange={(e) => checkBoxOnChange(e)}
        data-test-id="applicant-review-terms-checkbox"
      />
      <CheckboxLabel htmlFor="one">
        I consent to The Hiring Hub Ltd storing and displaying my review on its
        website.
      </CheckboxLabel>
    </ChecboxWrapper>
    {termsAccepted ? (
      <NextButton
        type="button"
        onClick={() => proceedToReview()}
        data-test-id="next-button"
      >
        Leave Review
      </NextButton>
    ) : (
      <FakeNextButton
        className="animated fadeInUp delay-4"
        type="button"
        data-test-id="fake-next-button"
      >
        Leave Review
      </FakeNextButton>
    )}
    <SmallPrint className="animated fadeIn delay-8">
      *Your review isn&apos;t public - only employers using Hiring Hub&apos;s
      recruiter marketplace can view it on {recruiterName}&apos;s profile page
      when deciding whether to work with them or not - and we only display your
      first name (no other info).
    </SmallPrint>
  </Wrapper>
);

Terms.propTypes = {
  termsAccepted: PropTypes.bool.isRequired,
  checkBoxOnChange: PropTypes.func.isRequired,
  proceedToReview: PropTypes.func.isRequired,
  candidateName: PropTypes.string,
  employerName: PropTypes.string,
  recruiterName: PropTypes.string,
};

Terms.defaultProps = {
  candidateName: PropTypes.isNull,
  employerName: PropTypes.isNull,
  recruiterName: PropTypes.isNull,
};

export default Terms;
